import { UnitColumn } from "../components/common/UnitTable/UnitTable"
import IncomeUnitType from "../types/unit/IncomeUnit"
import { ColumnInfo } from "./DataTable/ColumnInfo"
import { Option } from "../components/common/Dropdown/Dropdown"
import { Variable } from "../types/unit/Variable"

// Wraps values containing a delimiter, quote or line break so they stay in a single CSV cell
export const escapeCSVValue = (value: string): string => {
    return /[",\r\n]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value
}

export const getCSVCellValue = (unit: IncomeUnitType, column: UnitColumn | ColumnInfo): string => {
    let value: string | number | boolean | Variable[] | null | undefined = null
    if (column.valueFn) {
        value = column.valueFn(unit)
    } else {
        if (Object.hasOwn(column, "id")) {
            value = unit[(column as ColumnInfo).id as keyof IncomeUnitType]
        } else {
            value = unit[(column as UnitColumn).columnName as keyof IncomeUnitType]
        }
    }

    if (value === null || value === undefined) {
        return ""
    }

    if (column.type === "boolean") {
        if (typeof (value) === "string") {
            return value === "1" ? "True" : "False"
        }
        return value ? "True" : "False"
    }

    if (Object.hasOwn(column, "dropdown")) {
        const options: Option[] = (column as UnitColumn).dropdownSourceColumn ?
            ((column as UnitColumn).dropdown as Record<string, Option[]>)[unit[(column as UnitColumn).dropdownSourceColumn as keyof IncomeUnitType] as string] ?? []
            :
            (column as UnitColumn).dropdown as Option[]
        return options.find((option) =>  option.value as string === value as string)?.text ?? ""
    } else if (Object.hasOwn(column, "filterDropdown")) {
        const options = (column as ColumnInfo).filterDropdown as Option[]
        return options.find((option) => option.value as string === value as string)?.text ?? ""
    } else if (Object.hasOwn(column, "filterMultiDropdown")) {
        const variables = []
        const options = (column as ColumnInfo).filterMultiDropdown as Option[]
        for (const i in value as Variable[]) {
            variables.push(options.find((option) => option.value as string === (value as Variable[])[i].code)?.text ?? "")
        }
        return variables.filter(Boolean).join(", ")
    }

    return value as string
}

// Builds a CSV and triggers a browser download; pass raw values, escaping is handled here
export const downloadCSV = (fileName: string, headers: string[], rows: string[][]): void => {
    const headerRow = headers.map(escapeCSVValue).join(",")
    const dataRows = rows.map((row) => row.map(escapeCSVValue).join(","))
    // Prefixed with a BOM so Excel picks up the UTF-8 encoding
    const csv = "\uFEFF" + [headerRow, ...dataRows].join("\r\n")

    const downloadLink = document.createElement("a")
    downloadLink.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    downloadLink.download = fileName
    downloadLink.click()
}